import { get, chain, replace, startsWith } from "lodash"
import {
  createGetClassificationsTiersSelector,
  createGetClassificationsSelector,
  createGetCountriesMapSelector,
  createGetCurrenciesMapSelector,
  createGetCountriesSelector,
  createGetClassificationFacetsSelector,
  createGetSelectedClassificationsSelector,
  createGetSelectedClassificationsFilteredSelector,
  createGetClassificationFacetTreesSelector,
  createGetCurrenciesSelector,
  createGetFacetTypesSelector,
} from "helpers/facetSelectors"

export const getRawClassifications = state => get(state, "global.data.classifications.data.classifications")
const getModelCountries = state => get(state, "global.data.modelCountries.data")
const getModelCurrencies = state => get(state, "global.data.modelCurrencies.data")
const getRawCountries = state => get(state, "global.data.searchFacets.data.model.securitySearch.countries")
const getRawCurrencies = state => get(state, "global.data.searchFacets.data.model.securitySearch.currencies")
const getSelectedDate = (_, props) => get(props, "selectedDate")
const getSelectedCountries = (_, props) => props.selectedCountries
const getSelectedCurrencies = (_, props) => props.selectedCurrencies
const getRawSelectedClassifications = (_, props) => props.selectedClassifications
const getRawClassificationsValues = state => get(state, "global.data.classificationsValues.data")
const getRawClassificationsFacets = state => chain(get(state, "global.data.searchFacets.data.model.securitySearch"))
  .pickBy((i, key) => startsWith(key, "classification_"))
  .mapKeys((i, key) => replace(key, "classification_", ""))
  .value()

const getClassificationsTiers = createGetClassificationsTiersSelector(getRawClassifications, getSelectedDate)
export const getClassifications = createGetClassificationsSelector(getRawClassificationsValues, getClassificationsTiers)
const getCountriesMap = createGetCountriesMapSelector(getModelCountries)
const getCurrenciesMap = createGetCurrenciesMapSelector(getModelCurrencies)
export const getCountries = createGetCountriesSelector(getRawCountries, getCountriesMap, getSelectedCountries)
export const getClassificationFacets = createGetClassificationFacetsSelector(getRawClassificationsFacets, getClassifications)
export const getSelectedClassifications = createGetSelectedClassificationsSelector(getClassificationFacets, getRawSelectedClassifications)
export const getSelectedClassificationsFiltered = createGetSelectedClassificationsFilteredSelector(getSelectedClassifications, getClassifications)
export const getClassificationFacetTrees = createGetClassificationFacetTreesSelector(getClassificationFacets, getClassificationsTiers, getSelectedClassifications)
export const getCurrencies = createGetCurrenciesSelector(getRawCurrencies, getCurrenciesMap, getSelectedCurrencies)
export const getFacetTypes = createGetFacetTypesSelector(getCountries, getCurrencies, getClassificationFacetTrees, getSelectedClassificationsFiltered)
